<template>
  <div>
    <!-- الكارد الأول: البيانات الرئيسية -->
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <ValidationObserver v-slot="{ failed, passed }">
          <form>
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                  <h4 class="title">جدول المهام</h4>
                </div>
              </md-card-header>
              <md-card-content>
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mtb-25"
                  >
                    <md-field
                      :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                    >
                      <p class="validate">*</p>
                      <label>اسم جدول المهام</label>
                      <md-input v-model="taskScheduleName"></md-input>
                    </md-field>
                  </div>

                  <!-- الموظف -->
                  <div
                    class="md-layout-item md-size-30 md-small-size-100 mt-25 ml-15"
                  >
                    <model-list-select
                      class="input-must-rtl"
                      :list="employees"
                      v-model="employeeId"
                      option-value="key"
                      option-text="value"
                      placeholder="الموظف"
                    >
                    </model-list-select>
                  </div>

                  <!-- تاريخ من -->
                  <div
                    class="md-layout-item md-size-15 md-small-size-100 ml-15 mt-25"
                  >
                    <md-datepicker v-model="fromDate" :md-open-on-focus="false">
                      <label class="mr-28">تاريخ من</label>
                    </md-datepicker>
                  </div>

                  <!-- تاريخ إلى -->
                  <div
                    class="md-layout-item md-size-15 md-small-size-100 ml-15 mt-25"
                  >
                    <md-datepicker v-model="toDate" :md-open-on-focus="false">
                      <label class="mr-28">تاريخ إلى</label>
                    </md-datepicker>
                  </div>
                </div>

                <div class="md-layout">
                  <!-- مدة الجدول -->
                  <div
                    class="md-layout-item md-size-25 md-small-size-100 mt-25 ml-15"
                  >
                    <model-list-select
                      class="input-must-rtl"
                      :list="taskScheduleDurations"
                      v-model="taskScheduleDuration"
                      option-value="key"
                      option-text="value"
                      placeholder="نوع الجدول"
                    >
                    </model-list-select>
                  </div>

                  <div
                    class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                  >
                    <md-checkbox v-model="showTasksNotCompleted">
                      إظهار المهام الغير المنجزة
                    </md-checkbox>
                  </div>
                </div>

                <!-- أزرار الحفظ والجديد -->
                <div class="md-layout">
                  <div
                    class="md-layout-item md-size-100 mt-25 mtb-25 center-content"
                  >
                    <md-button
                      @click="saveToDB"
                      class="md-success btn_nanosoft"
                    >
                      حفظ
                    </md-button>

                    <md-button @click="clear" class="md-info btn_nanosoft">
                      جديد
                    </md-button>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- الكارد الثاني: التفاصيل -->
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">تفاصيل جدول المهام</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <!-- تفاصيل جدول المهام -->
            <div class="md-layout">
              <!-- تاريخ المهمة -->
              <div
                class="md-layout-item md-size-25 md-small-size-100 ml-15 mt-25"
              >
                <md-datepicker
                  v-model="detail.taskDate"
                  :md-open-on-focus="false"
                >
                  <label class="mr-28">تاريخ المهمة</label>
                </md-datepicker>
              </div>

              <!-- نوع المهمة -->
              <div
                class="md-layout-item md-size-20 md-small-size-100 ml-15 mtb-25"
              >
                <model-list-select
                  class="input-must-rtl"
                  :list="typesOfTasks"
                  v-model="detail.typeOfTaskId"
                  option-value="key"
                  option-text="value"
                  placeholder="اسم المهمة"
                >
                </model-list-select>
              </div>

              <!-- وصف المهمة -->
              <div
                class="md-layout-item md-size-25 md-small-size-100 ml-15 mtb-25"
              >
                <md-field>
                  <label>وصف المهمة</label>
                  <md-input v-model="detail.taskDescription"></md-input>
                </md-field>
              </div>

              <!-- مكان العمل -->
              <div
                class="md-layout-item md-size-20 md-small-size-100 ml-15 mtb-25"
              >
                <model-list-select
                  class="input-must-rtl"
                  :list="workPlaces"
                  v-model="detail.workPlaceId"
                  option-value="key"
                  option-text="value"
                  placeholder="مكان العمل"
                >
                </model-list-select>
              </div>
            </div>

            <!-- أزرار التحكم -->
            <div class="md-layout">
              <div class="md-layout-item md-size-100 mt-25 center-content">
                <md-button @click="addDetail" class="md-primary btn_nanosoft">
                  إضافة
                </md-button>
                <md-button
                  v-if="editingDetailIndex !== null"
                  @click="updateDetail"
                  class="md-warning btn_nanosoft"
                >
                  تحديث
                </md-button>
                <md-button
                  v-if="editingDetailIndex !== null"
                  @click="cancelEdit"
                  class="md-info btn_nanosoft"
                >
                  إلغاء
                </md-button>
              </div>
            </div>

            <!-- جدول التفاصيل -->
            <div class="md-layout mt-25" v-if="details.length > 0">
              <div class="md-layout-item md-size-100">
                <md-table
                  :value="details"
                  class="paginated-table table-striped table-hover"
                >
                  <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item, index }"
                  >
                    <md-table-cell md-label="تاريخ المهمة">
                      {{ formatDate(item.taskDate) }}
                    </md-table-cell>
                    <md-table-cell md-label="اسم المهمة">
                      {{ getTaskName(item.typeOfTaskId) }}
                    </md-table-cell>
                    <md-table-cell md-label="وصف المهمة">
                      {{ item.taskDescription || "-" }}
                    </md-table-cell>
                    <md-table-cell md-label="مكان العمل">
                      {{ getWorkPlaceName(item.workPlaceId) }}
                    </md-table-cell>
                    <md-table-cell md-label>
                      <md-button
                        class="md-just-icon md-warning md-simple ml-5"
                        @click.native="editDetail(index)"
                      >
                        <md-icon>edit</md-icon>
                      </md-button>
                      <md-button
                        class="md-just-icon md-danger md-simple"
                        @click.native="removeDetail(index)"
                      >
                        <md-icon>close</md-icon>
                      </md-button>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { ModelListSelect } from "vue-search-select";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  components: {
    ModelListSelect,
  },

  async created() {
    await this.init();
    await this.loadTypesOfTasks();
    await this.loadWorkPlaces();
  },

  data() {
    return {
      id: null,
      taskScheduleName: null,
      employeeId: null,
      fromDate: null,
      toDate: null,
      taskScheduleDuration: null,
      showTasksNotCompleted: false,
      details: [],
      detail: {
        typeOfTaskId: null,
        taskDate: null,
        taskDescription: null,
        workPlaceId: null,
      },
      tableData: [],
      typesOfTasksData: [],
      workPlacesData: [],
      editingDetailIndex: null,
    };
  },

  computed: {
    employees() {
      const employeesData = this.$store.getters["global/employeesData"];
      return employeesData ? employeesData.employees : [];
    },

    typesOfTasks() {
      return this.typesOfTasksData.map((task) => ({
        key: task.id,
        value: task.taskName,
      }));
    },

    workPlaces() {
      return this.workPlacesData.map((place) => ({
        key: place.id,
        value: place.name,
      }));
    },

    taskScheduleDurations() {
      return [
        { key: 1, value: "شهري" },
        { key: 2, value: "أسبوعي" },
      ];
    },
  },

  methods: {
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    async loadTypesOfTasks() {
      try {
        const { data } = await this.$axios.get(`/api/TypesOfTasks`);
        this.typesOfTasksData = data.data || [];
      } catch (error) {
        this.notifyVue("top", "center", "danger", "خطأ في تحميل أنواع المهام");
      }
    },

    async loadWorkPlaces() {
      try {
        const { data } = await this.$axios.get(`/api/WorkPlaces`);
        this.workPlacesData = data.data || [];
      } catch (error) {
        this.notifyVue("top", "center", "danger", "خطأ في تحميل أماكن العمل");
      }
    },

    addDetail() {
      if (this.editingDetailIndex !== null) {
        this.notifyVue("top", "center", "warning", "يرجى إنهاء التحديث أولاً");
        return;
      }

      if (!this.detail.typeOfTaskId) {
        this.notifyVue("top", "center", "warning", "يرجى اختيار اسم المهمة");
        return;
      }
      if (!this.detail.taskDate) {
        this.notifyVue("top", "center", "warning", "يرجى اختيار تاريخ المهمة");
        return;
      }

      this.details.push({
        typeOfTaskId: this.detail.typeOfTaskId,
        taskDate: this.detail.taskDate,
        taskDescription: this.detail.taskDescription,
        workPlaceId: this.detail.workPlaceId,
      });

      // إعادة تعيين نموذج التفاصيل
      this.detail.typeOfTaskId = null;
      this.detail.taskDescription = null;
      this.detail.workPlaceId = null;
    },

    removeDetail(index) {
      Swal.fire({
        text: "سيتم حذف هذا السطر، هل أنت متأكد؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.details.splice(index, 1);
          if (this.editingDetailIndex === index) {
            this.cancelEdit();
          }
          this.notifyVue("top", "center", "success", "تم الحذف بنجاح");
        }
      });
    },

    editDetail(index) {
      this.editingDetailIndex = index;
      const detailToEdit = this.details[index];
      this.detail.typeOfTaskId = detailToEdit.typeOfTaskId;
      this.detail.taskDate = detailToEdit.taskDate;
      this.detail.taskDescription = detailToEdit.taskDescription;
      this.detail.workPlaceId = detailToEdit.workPlaceId;
    },

    updateDetail() {
      if (!this.detail.typeOfTaskId) {
        this.notifyVue("top", "center", "warning", "يرجى اختيار اسم المهمة");
        return;
      }
      if (!this.detail.taskDate) {
        this.notifyVue("top", "center", "warning", "يرجى اختيار تاريخ المهمة");
        return;
      }

      this.details[this.editingDetailIndex] = {
        typeOfTaskId: this.detail.typeOfTaskId,
        taskDate: this.detail.taskDate,
        taskDescription: this.detail.taskDescription,
        workPlaceId: this.detail.workPlaceId,
      };

      this.cancelEdit();
    },

    cancelEdit() {
      this.editingDetailIndex = null;
      this.detail.typeOfTaskId = null;
      this.detail.taskDescription = null;
      this.detail.workPlaceId = null;
    },

    async saveToDB() {
      try {
        // التحقق من البيانات الأساسية
        if (!this.taskScheduleName) {
          this.notifyVue(
            "top",
            "center",
            "warning",
            "يرجى إدخال اسم جدول المهام"
          );
          return;
        }
        if (!this.employeeId) {
          this.notifyVue("top", "center", "warning", "يرجى اختيار الموظف");
          return;
        }
        if (!this.fromDate) {
          this.notifyVue("top", "center", "warning", "يرجى اختيار تاريخ من");
          return;
        }
        if (!this.toDate) {
          this.notifyVue("top", "center", "warning", "يرجى اختيار تاريخ إلى");
          return;
        }
        if (this.details.length === 0) {
          this.notifyVue(
            "top",
            "center",
            "warning",
            "يرجى إضافة مهمة واحدة على الأقل"
          );
          return;
        }

        const schema = {
          taskScheduleName: this.taskScheduleName,
          employeeId: this.employeeId,
          fromDate: this.formatDate(this.fromDate),
          toDate: this.formatDate(this.toDate),
          taskScheduleDuration: this.taskScheduleDuration,
          showTasksNotCompleted: this.showTasksNotCompleted,
          details: this.details.map((detail) => ({
            taskDate: this.formatDate(detail.taskDate),
            taskDescription: detail.taskDescription,
            typeOfTaskId: detail.typeOfTaskId,
            workPlaceId: detail.workPlaceId ? detail.workPlaceId : null,
          })),
        };

        let result = null;

        if (this.id) {
          // تحديث
          const { data } = await this.$axios.put(
            `api/TaskSchedule/${this.id}`,
            schema
          );
          result = data;
        } else {
          // إضافة جديد
          const { data } = await this.$axios.post("api/TaskSchedule", schema);
          result = data;
        }

        if (result.message) {
          this.notifyVue("top", "center", "success", result.message);
          // التحويل إلى صفحة المشاهدة بعد الحفظ
          const savedId = result.data?.id || this.id;
          if (savedId) {
            this.$router.push(`/pages/tasks-schedule/${savedId}`);
          }
        }
      } catch (error) {
        console.warn("error.response.data", error.response.data);
        if (error.response && error.response.data) {
          if (error.response.data.errors) {
            let result =
              error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ];
            return this.notifyVue("top", "center", "danger", result[0]);
          }
          if (error.response.data.message) {
            return this.notifyVue(
              "top",
              "center",
              "danger",
              error.response.data.message
            );
          }
        }
        this.notifyVue(
          "top",
          "center",
          "danger",
          error.message || "حدث خطأ أثناء الحفظ"
        );
      }
    },

    async init() {
      try {
        const { data } = await this.$axios.get(`/api/TaskSchedule`);
        this.tableData = data.data || [];
      } catch (error) {
        this.notifyVue("top", "center", "danger", "خطأ في تحميل البيانات");
      }
    },

    clear() {
      this.id = null;
      this.taskScheduleName = null;
      this.employeeId = null;
      this.fromDate = null;
      this.toDate = null;
      this.taskScheduleDuration = null;
      this.showTasksNotCompleted = false;
      this.details = [];
      this.detail = {
        typeOfTaskId: null,
        taskDate: null,
        workPlaceId: null,
        taskDescription: null,
      };
    },

    handleEdit(item) {
      this.id = item.id;
      this.taskScheduleName = item.taskScheduleName;
      this.employeeId = item.employeeId;
      this.fromDate = item.fromDate;
      this.toDate = item.toDate;
      this.taskScheduleDuration = item.taskScheduleDuration;
      this.showTasksNotCompleted = item.showTasksNotCompleted;
      this.details = item.details
        ? item.details.map((d) => ({
            typeOfTaskId: d.typeOfTaskId,
            taskDate: this.formatDate(d.taskDate),
            taskDescription: d.taskDescription,
            workPlaceId: d.workPlaceId,
          }))
        : [];

      // التمرير إلى أعلى الصفحة
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            const { data } = await this.$axios.delete(
              `/api/TaskSchedule/${item.id}`
            );
            if (data.message) {
              this.notifyVue("top", "center", "success", data.message);
              this.init();
            }
          } catch (error) {
            this.notifyVue("top", "center", "danger", "خطأ في الحذف");
          }
        }
      });
    },

    getEmployeeName(employeeId) {
      const employee = this.employees.find((emp) => emp.key === employeeId);
      return employee ? employee.value : "";
    },

    getTaskName(typeOfTaskId) {
      const task = this.typesOfTasksData.find((t) => t.id === typeOfTaskId);
      return task ? task.taskName : "";
    },

    getWorkPlaceName(workPlaceId) {
      const workPlace = this.workPlacesData.find((w) => w.id === workPlaceId);
      return workPlace ? workPlace.name : "";
    },

    formatDate(dateString) {
      if (!dateString) return "-";
      return moment(dateString).format("YYYY-MM-DD");
    },
  },
};
</script>

<style lang="scss" scoped>
.validate {
  color: red;
  font-weight: bold;
  margin-left: 5px;
  display: inline;
}
</style>
